import gql from 'graphql-tag';

export default gql`
  subscription refreshActiveOrders {
    orders: refreshActiveOrders {
      id
      expiryType
      fixClientID
      fixClOrdID
      fixOrderID
      fixQuoteID
      fixVenueOrderID
      instrument {
        id
      }
      limitPrice
      quote {
        id
      }
      side
      specifiedCurrency {
        id
        symbol
      }
      specifiedQuantity
      status
      timeCreated
      timeLastUpdated
      type
    }
  }
`;
